import { Controller, get } from "react-hook-form";
import { SelectField } from "../../ui";
import { AccountBankTypeEnum } from "../../../../pages/enum";

interface SelectAccountBankTypeProps {
    name: string;
    methods: any;
    disabled?: boolean;
    required?: boolean;
    label?: string;
}

export function SelectAccountBankType({
    name,
    methods,
    disabled = false,
    required = false,
    label = "Tipo de Conta",
}: SelectAccountBankTypeProps) {
    return (
        <Controller
            name={name}
            control={methods.control}
            render={({ field, formState: { errors } }) => {
                const error = get(errors, name);
                return (
                    <SelectField
                        label={label}
                        value={field.value || ""}
                        onChange={(e) => field.onChange(e.target.value)}
                        required={required}
                        disabled={disabled}
                        error={!!error}
                        helperText={error?.message as string}
                    >
                        <option value="">Selecione...</option>
                        <option value={AccountBankTypeEnum.CURRENT}>Conta Corrente</option>
                        <option value={AccountBankTypeEnum.SAVINGS}>Conta Poupança</option>
                    </SelectField>
                );
            }}
        />
    );
}
